export default {
  // Sidebar
  'Nova OS Proativa': 'Neue proaktive OS',
  'Interno': 'Intern',
  'Externo': 'Extern',
  'Preventiva': 'Präventiv',
  'Reaberta': 'Wiedereröffnet',
  'Execuções': 'Ausführungen',
  'Armazém': 'Lager',
  'Frota': 'Fuhrpark',
  'Sair': 'Verlassen',
  'Inventário': 'Inventar',

  // Nova Os
  'Voltar': 'Zurück',
  'Nova OS': 'Neue OS',
  'Operação': 'Betrieb',
  'Placa': 'Kennzeichen',
  'Segmento': 'Segment',
  'Problemas': 'Probleme',
  'Descrição do Problema': 'Problembeschreibung',
  'Gerar OS': 'OS erzeugen',
  'Cancelar': 'Abbrechen',

  // OS Interna
  "Nenhum resultado encontrado": 'Kein Ergebnis gefunden',
  "Exibindo resultado": 'Ergebnis anzeigen',
  "de": 'von',
  "Aberta há": 'Geöffnet seit',
  "Concluída em": 'Abgeschlossen am',

  // Ordem Servico
  "Detalhes": 'Details',
  "Mostrar": 'Anzeigen',
  "Esconder": 'Ausblenden',
  "Telefone": 'Telefon',
  "Data": 'Datum',
  "Início": 'Beginn',
  "Final": 'Ende',
  "Fornecedor": 'Lieferant',
  "Tipo": 'Typ',
  "Ciclo preventiva": 'Präventivzyklus',
  "Criticidade": 'Kritikalität',
  "Previsão de Atendimento": 'Serviceprognose',
  "Atendimento do Item": 'Artikelbearbeitung',
  "Observações": 'Hinweise',
  "Imagens": 'Bilder',
  "Salvar": 'Speichern',
  "Ordens de Serviço": 'Serviceaufträge',

  // OS Item
  "Iniciar": 'Starten',
  "Ações": 'Aktionen',
  "Continuar": 'Fortsetzen',
  "Pausar": 'Pausieren',
  "Registrar Peças": 'Teile registrieren',
  "Cancelar OS": 'OS abbrechen',
  "OS Externa": 'Externe OS',
  "Insira um serviço. Tente novamente.": 'Geben Sie einen Service ein. Versuchen Sie es erneut.',

  // ModalItems
  "Serviços": 'Services',
  "Observação": 'Hinweis',
  "Anexo de arquivos": 'Dateianhang',
  "Informe o valor total dos serviços/peças": 'Gesamtwert der Services/Teile angeben',
  "Informe o motivo do socorro em rota": 'Grund für Pannenhilfe angeben',
  "Informe o pneu utilizado neste serviço": 'Verwendeten Reifen angeben',
  "Foi trocado o pneu": 'Der Reifen wurde gewechselt',
  "Finalizar OS": 'OS abschließen',

  // Modal peças
  "Foi utilizado Peças?": 'Wurden Teile verwendet?',
  "Se foi utilizado peças neste atendimento, pressione 'Sim' na opção abaixo!":
    "Wenn bei diesem Service Teile verwendet wurden, drücken Sie unten 'Ja'!",
  "Não": 'Nein',
  "Sim": 'Ja',

  // Modal Itens Fim
  "Informe os itens utilizados neste serviço": 'Verwendete Artikel angeben',
  "Fechar": 'Schließen',
  "Peças": 'Teile',
  "Peça": 'Teil',
  "Quantidade": 'Menge',
  "Preço": 'Preis',
  "Informe o pneu novo": 'Neuen Reifen angeben',

  // Modal Pause
  "Informe a Justificativa": 'Begründung angeben',
  "Confirmar Pausa": 'Pause bestätigen',
  "Justificativa": 'Begründung',
  "Ir ao banheiro": 'Zur Toilette gehen',
  "Fim de expediente": 'Arbeitsende',
  "Atendimento": 'Service',
  "Refeição": 'Mahlzeit',
  "Aguardando Peças": 'Warten auf Teile',
  "Auxílio externo": 'Externe Hilfe',
  'Selecione qual peça está aguardando': 'Wählen Sie das wartende Teil',

  // Confirmar OS Externa
  "Confirmar OS Externa": 'Externe OS bestätigen',
  "Deseja realmente enviar OS": 'Möchten Sie die OS wirklich senden',
  "Confirmar": 'Bestätigen',

  // Lista de Execucao
  "Lista de execução": 'Ausführungsliste',
  "Nenhuma execução ativa": 'Keine aktive Ausführung',
  "Início Atendimento": 'Servicebeginn',
  "Encerrar OS": 'OS beenden',
  "Acessar OS": 'Auf OS zugreifen',
  "Colaborador": 'Mitarbeiter',
  "Execuções em Pause": 'Ausführungen in Pause',
  "Nenhuma execução em pause": 'Keine Ausführung in Pause',

  // Login
  "Torne sua rotina mais dinâmica": 'Machen Sie Ihre Routine dynamischer',
  "ACESSO AO SISTEMA": 'SYSTEMZUGANG',
  "Terminal Oficina": 'Werkstatt-Terminal',
  "Realize o login e tenha acesso ao controle": 'Melden Sie sich an und erhalten Sie Zugang zur Kontrolle',
  "e gestão de suas Ordens de Serviço": 'und Verwaltung Ihrer Serviceaufträge',
  "Mecânico Externo": 'Externer Mechaniker',
  "Acessar": 'Zugreifen',
  "Falha ao fazer login": 'Fehler bei der Anmeldung',

  // Filtro Internas
  "Ordenar": 'Sortieren',
  "Antigas Primeiro": 'Älteste zuerst',
  "Recentes Primeiro": 'Neueste zuerst',
  "Maior": 'Größer',
  "Menor": 'Kleiner',
  "Segmentos": 'Segmente',
  "Período": 'Zeitraum',
  "Execução": 'Ausführung',
  "Todos": 'Alle',
  "Pendentes": 'Offen',
  "Finalizadas": 'Abgeschlossen',
  "Aplicar filtro": 'Filter anwenden',
  "Limpar filtros": 'Filter löschen',
  "Esconder filtros": 'Filter ausblenden',
  "Criado por": 'Erstellt von',
  "Usuário": 'Benutzer',

  // Os Preventivas
  "Filtre as OS Preventivas": 'Präventive OS filtern',
  "Preventivas Vencidas": 'Abgelaufene Präventive',
  "Preventivas à Vencer": 'Anstehende Präventive',
  "Carrocerias Vencidas": 'Abgelaufene Aufbauten',
  "Atualizar": 'Aktualisieren',

  // Modais Preventivas
  "ACAO": 'AKTION',
  "PLACA": 'KENNZEICHEN',
  "PROXIMO_CICLO": 'NÄCHSTER_ZYKLUS',
  "VENCIMENTO": 'FÄLLIGKEIT',
  "PROXIMO_KM": 'NÄCHSTER_KM',
  "KM_ATUAL": 'AKTUELLER_KM',
  "Vincular Fornecedor": 'Lieferant verknüpfen',

  // Inventário
  "Não contados": 'Nicht gezählt',
  "Contados": 'Gezählt',
  "Ordenação": 'Sortierung',
  "Total Itens": 'Gesamtartikel',

  // Modal Mecanico
  "Informe os três primeiros dígitos do seu CPF para confirmar sua identidade":
    'Geben Sie die ersten drei Ziffern Ihres CPF ein, um Ihre Identität zu bestätigen',
  'Confirmar identidade': 'Identität bestätigen',

  "Erro do Motorista": 'Fahrerfehler',
  "Defeito não Encontrado": 'Kein Defekt gefunden',

  "Informe o serviço": 'Service angeben',
  "Insira os Itens": 'Artikel eingeben',

  "Alterar Fornecedor": 'Lieferant ändern',
  "Preventivas Armazém": 'Präventive Lager',
  "Outros": 'Sonstige',
  "Ver Encerradas": 'Abgeschlossene anzeigen',
  "Tem dúvida?": 'Haben Sie Fragen?',
  "Aguardando Aprovação": 'Warten auf Genehmigung',

  // Borracharia
  'Bem vindo(a) ao Terminal da Borracharia!': 'Willkommen im Reifen-Terminal!',
  'Realize a gestão de pneus pelo novo terminal da borracharia!':
    'Führen Sie die Reifenverwaltung über das neue Reifen-Terminal durch!',
  'Aferição': 'Prüfung',
  'Movimentação/Troca': 'Bewegung/Austausch',
  'Descarte': 'Entsorgung',
  'Borracharia': 'Reifenwerkstatt',
  'Placas': 'Kennzeichen',

  // Gerais
  "Portugues": 'Português',
  "Nunca feito": 'Nie durchgeführt',
  "Ingles": 'Deutsch',
    'Frances': "Französisch",
    'Alemao': 'Deutsch',
    'Holandes': 'Niederländisch',

    
  "O ESFORÇO DE HOJE É O SUCESSO DE AMANHA": "DIE ANSTRENGUNG VON HEUTE IST DER ERFOLG VON MORGEN",

  "CODIGO OS": "AUFTRAGSCODE",
  "TODOS": "ALLE",
  "Socorro em Rota pendente de atendimento": "Pannenhilfe ausstehend",
  "FILTROS": "FILTER",
  "Salvar Filtro": "Filter speichern",
  "Motorista": "Fahrer",
  "Orçamento": "Budget",
  "Confirmar Orçamento": "Budget bestätigen",
  "Deseja pausar esta OS para aguardar o orçamento?": "Möchten Sie diesen Arbeitsauftrag pausieren, um auf das Budget zu warten?",
  "Valor": "Wert",
  "Pausar OS": "Arbeitsauftrag pausieren",
  "Comentarios": "Kommentare",
  "Insira um comentário": "Kommentar eingeben",
  "Enviar OS": "Arbeitsauftrag senden",
  "Selecione uma justificativa": "Begründung auswählen",
  "Anexos": "Anhänge",
  "OS Socorro em Rotas": "Arbeitsauftrag Pannenhilfe",
  "Confirmar Cancelamento": "Stornierung bestätigen",
  "Buscar Placa": "Kennzeichen suchen",
  "Pesquisa de OS por placa": "Arbeitsauftragssuche nach Kennzeichen",
  "CONTRATO_CONCESSIONARIA": "KONZESSIONSVERTRAG",

  "Ordem gerada com sucesso": "Auftrag erfolgreich erstellt",
  "Sucesso": "Erfolg",
  "Selecionar Todos": "Alle auswählen",
  "Descrição": "Beschreibung",
  "Registrar Serviços": "Dienstleistungen registrieren",
  "Visualizar Itens": "Elemente anzeigen",
  "Clique no botão a direita para registrar as peças": "Klicken Sie auf die Schaltfläche rechts, um die Teile zu registrieren",

  "Selecionar técnico": "Techniker auswählen",
  "KM atual/Horimetro": "Aktueller Kilometerstand / Betriebsstundenzähler",
  "Deseja inserir alguma imagem no atendimento": "Möchten Sie dem Einsatz ein Bild hinzufügen?",
  "Para concluir a ação, selecione abaixo o técnico responsável": "Um die Aktion abzuschließen, wählen Sie unten den verantwortlichen Techniker aus",
  "Trabalhando": "In Arbeit",
  "Matricula": "Matrikelnummer",
  "Serviços registrado com sucesso": "Dienstleistungen erfolgreich registriert",
  "Função": "Funktion",
  "Enviar Anexos": "Anhänge senden",
  "Gerar Preventiva Programada": "Geplante präventive Wartung generieren",
  "OS Preventiva Programada": "Geplanter präventiver Arbeitsauftrag",
  "Finalize todas as peças e serviços para encerrar o atendimento": "Schließen Sie alle Teile und Dienstleistungen ab, um den Einsatz zu beenden",
  "Insira um KM maior que o anterior": "Geben Sie einen Kilometerstand ein, der höher als der vorherige ist",
  "Insira um KM maior que o atual": "Geben Sie einen Kilometerstand ein, der höher als der aktuelle ist",
  "Inserir anexos": "Anhänge hinzufügen",
  "Planos Preventivos": "Präventive Pläne",
  "Filtro": "Filter",
  "ULTIMA": "LETZTE",
  "Gerar Preditiva": "Prädiktive Wartung generieren",
  "Carregando": "Laden",
  "OS Preventiva Programada Armazém": "Geplanter präventiver Arbeitsauftrag – Lager",
  "Gerar OS Preventiva Programada": "Geplanten präventiven Arbeitsauftrag generieren",
  "OS Preventivas à Vencer": "Präventive Arbeitsaufträge vor Fälligkeit",
  "OS de Transição": "Übergangsbetriebssystem",

  "IMEDIATA": "SOFORT",
  "EMERGENCIAL": "NOTFALL",
  "ALTA": "HOCH",
  "MÉDIA": "MITTEL",
  "LEVE": "NIEDRIG"

}
